import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#about_batch",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder text-light m-0" }
const _hoisted_5 = { class: "row container my-5" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "list-group" }
const _hoisted_8 = { class: "list-group-item" }
const _hoisted_9 = {
  key: 0,
  class: "badge badge-secondary float-right"
}
const _hoisted_10 = {
  key: 1,
  class: "badge badge-secondary float-right"
}
const _hoisted_11 = {
  key: 2,
  class: "badge badge-secondary float-right"
}
const _hoisted_12 = { class: "list-group-item" }
const _hoisted_13 = {
  key: 0,
  class: "badge badge-secondary float-right"
}
const _hoisted_14 = { class: "list-group-item" }
const _hoisted_15 = {
  key: 0,
  class: "badge badge-secondary float-right"
}
const _hoisted_16 = { class: "list-group-item" }
const _hoisted_17 = {
  key: 0,
  class: "badge badge-secondary float-right"
}
const _hoisted_18 = { class: "list-group-item" }
const _hoisted_19 = {
  key: 0,
  class: "badge badge-secondary float-right"
}
const _hoisted_20 = { class: "list-group-item" }
const _hoisted_21 = {
  key: 0,
  class: "badge badge-secondary float-right"
}
const _hoisted_22 = { class: "list-group-item" }
const _hoisted_23 = { class: "badge badge-secondary float-right" }
const _hoisted_24 = { class: "list-group-item" }
const _hoisted_25 = { class: "badge badge-secondary float-right" }
const _hoisted_26 = { class: "list-group-item" }
const _hoisted_27 = { class: "badge badge-secondary float-right" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "list-group" }
const _hoisted_30 = { class: "list-group-item" }
const _hoisted_31 = { class: "badge badge-secondary float-right" }
const _hoisted_32 = { class: "list-group-item" }
const _hoisted_33 = { class: "badge badge-secondary float-right" }
const _hoisted_34 = { class: "list-group-item" }
const _hoisted_35 = { class: "badge badge-secondary float-right" }
const _hoisted_36 = { class: "list-group-item" }
const _hoisted_37 = { class: "badge badge-secondary float-right" }
const _hoisted_38 = { class: "list-group-item" }
const _hoisted_39 = { class: "badge badge-secondary float-right" }
const _hoisted_40 = { class: "list-group-item" }
const _hoisted_41 = { class: "badge badge-secondary float-right" }
const _hoisted_42 = { class: "list-group-item" }
const _hoisted_43 = { class: "badge badge-secondary float-right" }
const _hoisted_44 = { class: "list-group-item" }
const _hoisted_45 = { class: "badge badge-secondary float-right" }
const _hoisted_46 = { class: "list-group-item" }
const _hoisted_47 = { class: "badge badge-secondary float-right" }
const _hoisted_48 = { class: "list-group-item" }
const _hoisted_49 = { class: "badge badge-secondary float-right" }
const _hoisted_50 = { class: "list-group-item" }
const _hoisted_51 = { class: "badge badge-secondary float-right" }
const _hoisted_52 = { class: "list-group-item" }
const _hoisted_53 = { class: "badge badge-secondary float-right" }
const _hoisted_54 = { class: "list-group-item" }
const _hoisted_55 = { class: "badge badge-secondary float-right" }
const _hoisted_56 = { class: "card mb-5 mb-xl-10" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#about_batch",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Batch Class Schedule")
  ])
], -1)
const _hoisted_58 = { class: "form-group remove_form_padding" }
const _hoisted_59 = { class: "form-group mb-4" }
const _hoisted_60 = { class: "badge badge-primary mr-4" }
const _hoisted_61 = { class: "badge badge-info mr-4" }
const _hoisted_62 = { class: "badge badge-success mr-4" }
const _hoisted_63 = { class: "badge badge-warning mr-4 mt-4" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"border":"1px solid #b5b5c3"} }, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, "Days"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Time"),
    /*#__PURE__*/_createElementVNode("th", null, "End Time"),
    /*#__PURE__*/_createElementVNode("th", null, "Daily Hours")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, " About Batch " + _toDisplayString(_ctx.batchInfoData?.batch_attendance_summary?.total_training_days), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _createTextVNode(" Batch Status " + _toDisplayString(_ctx.batchInfoData?.batch_attendance_summary?.total_training_days) + " ", 1),
              (_ctx.batchInfoData?.end_date <= this.today)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Completed"))
                : (
                _ctx.batchInfoData?.start_date <= this.today &&
                _ctx.batchInfoData?.end_date >= this.today
              )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Running"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, " Upcoming "))
            ]),
            _createElementVNode("li", _hoisted_12, [
              (_ctx.batchInfoData?.batch_training_summery)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.t_enrolled) + "/" + _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.f_enrolled), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" Enrolled/Female ")
            ]),
            _createElementVNode("li", _hoisted_14, [
              (_ctx.batchInfoData.batch_attendance_summery)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.batchInfoData?.batch_attendance_summery?.total_training_days) + "/" + _toDisplayString(_ctx.batchInfoData?.batch_attendance_summery?.completed), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" Training Days ")
            ]),
            _createElementVNode("li", _hoisted_16, [
              (_ctx.batchInfoData?.batch_training_summery)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.t_assessed) + "/" + _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.f_assessed), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" Assessed/Female ")
            ]),
            _createElementVNode("li", _hoisted_18, [
              (_ctx.batchInfoData?.batch_training_summery)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.t_certified) + "/" + _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.f_certified), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" Certified/Female ")
            ]),
            _createElementVNode("li", _hoisted_20, [
              (_ctx.batchInfoData?.batch_training_summery)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.t_employed) + "/" + _toDisplayString(_ctx.batchInfoData?.batch_training_summery?.f_employed), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" Employed/Female ")
            ]),
            _createElementVNode("li", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.batchInfoData?.claim_1_batch?.bill_no), 1),
              _createTextVNode(" Claim-1 ")
            ]),
            _createElementVNode("li", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.batchInfoData?.claim_2_batch?.bill_no), 1),
              _createTextVNode(" Claim-2 ")
            ]),
            _createElementVNode("li", _hoisted_26, [
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.batchInfoData?.claim_3_batch?.bill_no), 1),
              _createTextVNode(" Claim-3 ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("ul", _hoisted_29, [
            _createElementVNode("li", _hoisted_30, [
              _createTextVNode(" Tranche: "),
              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.batchInfoData?.tranche_info?.label), 1)
            ]),
            _createElementVNode("li", _hoisted_32, [
              _createTextVNode(" Association: "),
              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.batchInfoData?.entity_info?.entity_short_name), 1)
            ]),
            _createElementVNode("li", _hoisted_34, [
              _createTextVNode(" Training Institute: "),
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.batchInfoData?.institute_info?.institute_name), 1)
            ]),
            _createElementVNode("li", _hoisted_36, [
              _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.batchInfoData?.course_info?.course_name), 1),
              _createTextVNode(" Course: ")
            ]),
            _createElementVNode("li", _hoisted_38, [
              _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.batchInfoData?.batch_number), 1),
              _createTextVNode(" Batch: ")
            ]),
            _createElementVNode("li", _hoisted_40, [
              _createTextVNode(" Training Location: "),
              _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.batchInfoData?.training_location), 1)
            ]),
            _createElementVNode("li", _hoisted_42, [
              _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.batchInfoData?.training_capacity), 1),
              _createTextVNode(" Training Capacity: ")
            ]),
            _createElementVNode("li", _hoisted_44, [
              _createTextVNode(" Start Date: "),
              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.batchInfoData?.start_date
                  ? _ctx.moment(_ctx.batchInfoData?.start_date).format('DD-MM-YYYY')
                  : _ctx.batchInfoData?.start_date), 1)
            ]),
            _createElementVNode("li", _hoisted_46, [
              _createTextVNode(" End Date: "),
              _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.batchInfoData?.end_date
                  ? _ctx.moment(_ctx.batchInfoData?.end_date).format('DD-MM-YYYY')
                  : _ctx.batchInfoData?.end_date), 1)
            ]),
            _createElementVNode("li", _hoisted_48, [
              _createTextVNode(" Training Start Date: "),
              _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.batchInfoData?.start_date
                ? _ctx.moment(_ctx.batchInfoData?.start_date).format('DD-MM-YYYY')
                : _ctx.batchInfoData?.start_date), 1)
            ]),
            _createElementVNode("li", _hoisted_50, [
              _createTextVNode(" Training End Date: "),
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.batchInfoData?.end_date
                ? _ctx.moment(_ctx.batchInfoData?.end_date).format('DD-MM-YYYY')
                : _ctx.batchInfoData?.end_date), 1)
            ]),
            _createElementVNode("li", _hoisted_52, [
              _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.batchInfoData?.total_training_days), 1),
              _createTextVNode(" Total Training Days: ")
            ]),
            _createElementVNode("li", _hoisted_54, [
              _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.batchInfoData?.total_training_hours), 1),
              _createTextVNode(" Total Training Hours: ")
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_56, [
      _hoisted_57,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchInfoData.term_details, (info, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "panel-body container mt-5",
          key: index
        }, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("span", _hoisted_60, [
                _createTextVNode("Term: "),
                _createElementVNode("span", null, _toDisplayString(index), 1)
              ]),
              _createElementVNode("span", _hoisted_61, [
                _createTextVNode("Start Date: "),
                _createElementVNode("span", null, _toDisplayString(info?.start_date
                ? _ctx.moment(info?.start_date).format('DD-MM-YYYY')
                : info?.start_date), 1)
              ]),
              _createElementVNode("span", _hoisted_62, [
                _createTextVNode("End Date: "),
                _createElementVNode("span", null, _toDisplayString(info?.end_date
                  ? _ctx.moment(info?.end_date).format('DD-MM-YYYY')
                  : info?.end_date), 1)
              ]),
              _createElementVNode("span", _hoisted_63, [
                _createTextVNode("Class Type: "),
                (info?.class_type == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Class Work"))
                  : _createCommentVNode("", true),
                (info?.class_type == 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_65, "Internship"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("table", _hoisted_66, [
              _hoisted_67,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.details, (dinfo, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: dinfo,
                    class: "tr_clone_1 border border-gray-400"
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(dinfo?.training_day), 1),
                    _createElementVNode("td", null, _toDisplayString(dinfo.start_time
                    ? _ctx.moment(dinfo?.start_time, 'hh:mm').format('LT')
                    : 'No time found'), 1),
                    _createElementVNode("td", null, _toDisplayString(dinfo.end_time
                    ? _ctx.moment(dinfo?.end_time, 'hh:mm').format('LT')
                    : 'No time found'), 1),
                    _createElementVNode("td", null, _toDisplayString(dinfo?.daily_hour), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      }), 128))
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ], 64))
}